import { DECIMAL } from './DECIMAL.js';
import { INTEGER } from './INTEGER.js';

export const INTEGER_DECIMAL: string = `${INTEGER} or ${DECIMAL}`;
